import Repository from './Repository';

const resource = '/districts';

export default {
  /**
   * Get District List
   * @param {object} params
   *
   * @property {string} q - filter district by name
   * @property {number, string} per_page - how many district data to show
   * @property {number, string} page - filter district by page number
   *
   * @returns {Promise}
   */
  getDistricts(params = {}) {
    return Repository.get(`${resource}`, { params });
  },

  /**
   * get district by district ID
   * @param {number} id - ID of the district
   *
   * @returns {Promise}
   */
  getDistrictById(id = null) {
    return Repository.get(`${resource}/${id}`);
  },

  /**
   * Store District
   * @returns {Promise}
   */
  createDistrict(body) {
    return Repository.post(`${resource}`, body);
  },

  /**
   * update District
   * @param {object} body - form request body
   * @param {number} id - ID of the district

   * @returns {Promise}
   */
  updateDistrict(body, id = null) {
    return Repository.put(`${resource}/${id}`, body);
  },

  /**
   * Delete district by district ID
   * @param {number} id - ID of the district
   *
   * @returns {Promise}
   */
  deleteDistrictById(id = null) {
    return Repository.delete(`${resource}/${id}`);
  },
};
